import React, { useState, useContext } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'
import UnmovingProductsInnerStyle from './css/UnmovingProductsInnerStyle'
import { unmovingProductsContext } from './UnmovingProductsController'
import { formatNumber, simpleDateString } from '../../../../../utilities/utilities'

function UnmovingProductsInner() {
  const unmovingProductsController = useContext(unmovingProductsContext)
  const { app } = unmovingProductsController
  const date = unmovingProductsController.date[0]
  const [unmovingProducts, setUnmovingProducts] = unmovingProductsController.unmovingProducts
  const [upSorted, setUPSorted] = useState(true)

  const onClickSort = (e) => {
    switch(e.target.id) {
      case 'inventory':
        unmovingProducts.sort((a, b) => {
          let sorted
          if (!upSorted)
            sorted = a.inventory - b.inventory
          else
            sorted = b.inventory - a.inventory
          return sorted
        })
      break
      case 'product-name':
      unmovingProducts.sort((a, b) => {
        let x, y
        if (!upSorted) {
          x = a.brand.toLowerCase()
          y = b.brand.toLowerCase()
        } else {
          x = b.brand.toLowerCase()
          y = a.brand.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
      break
      default:
    }

    setUPSorted(!upSorted)
    setUnmovingProducts(unmovingProducts)
  }

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div id='unmoving-products-container' className='printable'>
          <h3>Unmoving Products Report</h3>
          <br />
          <div className='dates-header-container'>
            <div className='date-left'>
              <div style={{display: 'flex'}}> <div style={{fontWeight: 'bold', width: '50px'}}>From:</div>{simpleDateString(new Date(date.from))}</div>
              <div style={{display: 'flex'}}><div style={{fontWeight: 'bold', width: '50px'}}>To:</div>{simpleDateString(new Date(date.to))}</div>
            </div>
            <div className='date-right'>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
          </div>
          <br />
          <table className='unmoving-products-table'>
            <thead>
              <tr>
                <th>
                  <div
                    id='product-name'
                    className='sortable-header'
                    onClick={onClickSort}
                    title='sort'
                    style={{paddingLeft: '0', textAlign: 'left'}}>
                    Product Name
                  </div>
                </th>
                <th style={{textAlign: 'left'}}>Unit</th>
                <th>
                  <div
                    id='inventory'
                    className='sortable-header'
                    onClick={onClickSort}
                    title='sort'>
                    Inventory
                  </div>
                </th>
              </tr>
            </thead>
            {
              (unmovingProducts)
              ? unmovingProducts.map((up, index) => (
                  <tbody key={index}>
                    <tr>
                      <td>{`${up.brand} ${up.name} ${up.description}`}</td>
                      <td>{up.unit_description}</td>
                      <td style={{textAlign: 'center'}}>{formatNumber(up.inventory)}</td>
                    </tr>
                  </tbody>
                ))
              : null
            }
            <tbody>
              <tr>
                <td colSpan='3'><b>Number of Items:</b> {(unmovingProducts) ? unmovingProducts.length : 0}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <UnmovingProductsInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(UnmovingProductsInner)